import React, { useEffect, useState } from "react";
import { blogItems, otherPagesItems } from "../Data/Navbar/navbar";
import { Collapse, Container, NavItem, Navbar, NavbarBrand, NavbarToggler,NavLink } from "reactstrap";
import { Link } from "react-router-dom";

const BlogNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 60) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Navbar className={`navbar-expand-lg theme-nav fixed-top ${isScrolled ? "darkHeader" : ""}`}>
      <Container className='d-lg-flex align-items-center'>
      <div className="d-flex align-items-centers justify-content-between">
      <NavbarBrand href={`${process.env.PUBLIC_URL}/`}>
          <img src='assets/images/logo.png' alt='logo' />
        </NavbarBrand>
        <NavbarToggler type='button' onClick={toggle}>
          <span className='navbar-toggler-icon'>
            <i className='fa fa-align-justify' aria-hidden='true'></i>
          </span>
        </NavbarToggler>
        </div>
        <Collapse className='navbar-collapse justify-content-end' id='mainmenu' isOpen={isOpen}>
          <ul className='navbar-nav ml-auto' id='mymenu'>
            <NavItem>
              <Link className='nav-link' to={`${process.env.PUBLIC_URL}/home`}>
                Home
              </Link>
            </NavItem>
            <NavItem>
            <Link className='nav-link' to={`${process.env.PUBLIC_URL}/home`}>
                about
              </Link>
            </NavItem>
            <NavItem>
            <Link className='nav-link' to={`${process.env.PUBLIC_URL}/home`}>
                feature
              </Link>
            </NavItem>

            <NavItem>
            <Link className='nav-link' to={`${process.env.PUBLIC_URL}/home`}>
                screenshot
              </Link>
            </NavItem>

            <NavItem>
            <Link className='nav-link' to={`${process.env.PUBLIC_URL}/home`}>
                team
              </Link>
            </NavItem>
            <NavItem className='dropdown'>
              <a href='#news' className='dropdown-toggle nav-link' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>
                Blog
              </a>
              <ul className='dropdown-menu'>
                {blogItems.map((item, i) => {
                  return (
                    <NavItem key={i}>
                      <Link className='nav-link' to={item.link}>
                        {item.label}
                      </Link>
                    </NavItem>
                  );
                })}
              </ul>
            </NavItem>
            <NavItem>
            <Link className='nav-link' to={`${process.env.PUBLIC_URL}/home`}>
                contact us
              </Link>
            </NavItem>
            <NavItem className='dropdown'>
              <Link className='nav-link dropdown-toggle' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>
                Other Page
              </Link>
              <ul className='dropdown-menu'>
                {otherPagesItems.map((item, i) => {
                  return (
                    <NavItem key={i}>
                      <NavLink className='nav-link' href={item.link}>
                        {item.label}
                      </NavLink>
                    </NavItem>
                  );
                })}
              </ul>
            </NavItem>
          </ul>
        </Collapse>
      
      </Container>
    </Navbar>
  );
};

export default BlogNav;
